module.exports = __webpack_public_path__ + "img/home_img.ca217c00.png";